import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { cloneDeep } from 'lodash';
import { useGetServerConfig } from '@app/common/queries/server-config';
import auth from '@app/common/auth/auth';
import { useFeatureFlagMap } from '@common/queries/feature-flags';
import serverConfig from '@common/server-config-context/server-config';
import { licenseActivationService } from '@common/licensing/license-activation-service';
export const ServerConfigContext = createContext(serverConfig);
export function useServerConfigContext() {
    const context = useContext(ServerConfigContext);
    if (context === undefined) {
        throw new Error('useNotificationsFormContext must be used within SharedFormContext');
    }
    return context;
}
export function useFeatureFlag(...features) {
    const context = useServerConfigContext();
    return useMemo(() => {
        return features.every(feature => context.hasFeature(feature));
    }, [context, features]);
}
export function ServerConfigProvider({ children }) {
    const enableQuery = auth.isAuthenticated() && licenseActivationService.hasLicense();
    const { data: config } = useGetServerConfig({ enabled: enableQuery });
    const { data: featureFlagsMap } = useFeatureFlagMap(enableQuery);
    const context = useMemo(() => {
        return cloneDeep(serverConfig.initialize({ config, featureFlagsMap }));
    }, [config, featureFlagsMap]);
    return _jsx(ServerConfigContext.Provider, { value: context, children: children });
}
